"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newbuildingPromoScheme = void 0;
const newbuildingPromoScheme = exports.newbuildingPromoScheme = {
  id: 1,
  isLoaded: false,
  minPrice: 0,
  undergroundInfo: null,
  developerLogoUrl: '',
  developerName: '',
  imageUrl: '',
  url: '',
  statusDisplay: '',
  name: '',
  address: ''
};